import { Message } from 'element-ui'
import cloneDeep from 'lodash/cloneDeep'

/**
 * 将二进制转成指定文件下载
 * @params {Blob} data 二进制数据
 * @params {String} fileName 文件名（包含后缀）
 */
export function downloadBlobFile(data, fileName) {
  const blob = new Blob([data])

  // 兼容IE浏览器
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
    return
  }

  const a = document.createElement('a')
  a.download = fileName
  a.href = URL.createObjectURL(blob)
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}

/**
 * 复制文本（String中加入 /n 可换行）
 * @param {String} text
 */
export function copy(text) {
  if (!text) return
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    Message.success('复制成功')
  } catch (error) {
    Message.error('当前浏览器不支持复制')
  }
}

/**
 * 返回保留特定小数位并四舍五入的数值
 * @param {Number} number 需要四舍五入的参数
 * @param {Number} precision 规定小数的位数
 * @returns {Number}
 */
export function rounding(number, precision) {
  return parseFloat(Math.round(Number(number) * Math.pow(10, precision)) / Math.pow(10, precision))
}

/**
 * 判断元素是否出现了省略号
 * @param {HTMLElement} element 需要判断的DOM元素
 * @returns {Boolean} true/false
 */
export function ellipsis(element) {
  return element && element.scrollWidth > element.offsetWidth
}

/**
 * 删除字符串中的换行符
 * @param {String} value
 * @returns {String}
*/
export function replaceStr(value) {
  return value && value.trim().replace(/(\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029))/g, '')
}

/**
 * 根据任意子级ID获取其所有父级ID
 * @param {Array} array 数据源
 * @param {number} id 当前查找元素的ID
 */
export function getPathName(array, id) {
  let stack = []
  let going = true
  let walker = (array, id) => {
    array.forEach((item) => {
      if (!going) return
      stack.push(item['id'])
      if (item['id'] === id) {
        going = false
      } else if (item['children']) {
        walker(item['children'], id)
      } else {
        stack.pop()
      }
    });
    if (going) stack.pop()
  }
  walker(array, id)
  return stack.join(',')
}

/**
 * 生成uuid
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * base64转file
 * @param {String} base64Str
 * @returns {File}
 */
export function base64ToFile(base64Str, fileName) {
  const arr = base64Str.split(',');
  console.log('arr', arr)
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  const file = new File([u8arr], fileName, { type: mime });
  return file;
}

// /**
//  * 为空字段设置值为'-'
//  *
//  * @param {Array} data 源数据
//  * @returns 改造后的数据
//  */
// export function completion(data) {
//   if (data instanceof Array || data.length > 0) {
//     let array = cloneDeep(data)
//     array = array.map((item) => {
//       for (let key in item) {
//         if (item[key] instanceof Array) {
//           completion(item[key])
//         } else if (item[key] instanceof Object) {
//           //
//         } else {
//           if (!item[key] && item[key] !== 0) {
//             item[key] = '-';
//           }
//         }
//       }
//       return item;
//     })
//     return array;
//   }
//   return data;
// }
